var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTransmittalIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.7691 2.24268C21.6565 2.13075 21.5142 2.05325 21.359 2.0193C21.2038 1.98535 21.0422 1.99636 20.893 2.05103L2.53842 8.71735C2.38012 8.77732 2.24384 8.88397 2.14767 9.02313C2.05151 9.16229 2 9.32738 2 9.49648C2 9.66557 2.05151 9.83066 2.14767 9.96982C2.24384 10.109 2.38012 10.2156 2.53842 10.2756L10.5477 13.4754L13.7514 21.475C13.8116 21.6262 13.9148 21.7564 14.0482 21.8497C14.1817 21.943 14.3395 21.9952 14.5023 22C14.6709 21.9965 14.8345 21.9421 14.9715 21.844C15.1085 21.7458 15.2126 21.6084 15.2699 21.45L21.9443 3.11764C22.0011 2.97021 22.0148 2.80968 21.9838 2.65476C21.9528 2.49985 21.8783 2.35694 21.7691 2.24268ZM14.5023 18.8335L12.1746 13.0005L16.1709 9.009L14.9945 7.83406L10.9649 11.8589L5.15812 9.50064L19.7834 4.22591L14.5023 18.8335Z",
    fill: "#192048"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransmittalIcon);
export default __webpack_public_path__ + "static/media/TransmittalIcon.a9ecdc15d3f4fb03d99cea8a207222f0.svg";
export { ForwardRef as ReactComponent };